module.exports = __webpack_public_path__ + "img/save_outlined_32.11dea8ba.svg";